/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReceiverMobileColumnFormatter = (cellContent, row, rowIndex) => {
  const { receiverMobile } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {receiverMobile ? receiverMobile : `-`}
      </div>
      <> </>
    </>
  );
};
